import { MenuItem, TextField, TextFieldProps, TextFieldVariants } from '@mui/material';
import { currencySchema } from '@procureai/schemas';
import { ForwardedRef, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

export type CurrencySelectProps<Variant extends TextFieldVariants = TextFieldVariants> = Omit<
  TextFieldProps<Variant>,
  'children'
>;

const CurrencySelectInner = <Variant extends TextFieldVariants = TextFieldVariants>(
  props: CurrencySelectProps<Variant>,
  ref: ForwardedRef<HTMLDivElement>,
) => {
  const { t } = useTranslation(I18nNamespace.common, { keyPrefix: 'CurrencySelect' });
  return (
    <TextField
      ref={ref}
      select
      label={t('label')}
      {...props}
      slotProps={{
        inputLabel: { shrink: true },
      }}
    >
      {currencySchema.options.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </TextField>
  );
};

export const CurrencySelect = forwardRef(CurrencySelectInner) as <
  Variant extends TextFieldVariants = TextFieldVariants,
>(
  props: CurrencySelectProps<Variant> & {
    ref?: ForwardedRef<HTMLDivElement>;
  },
) => ReturnType<typeof CurrencySelectInner>;
